import type { FormatConfig } from "../types"

/**
 * Configuración predefinida para duración en formato HH:MM:SS
 * Acepta solo números y dos puntos, formatea automáticamente a HH:MM:SS
 */
export const DURATION_CONFIG: FormatConfig = {
  transform: (value: string) => {
    // Remover todo excepto números
    const cleaned = value?.replace(/\D/g, "")
    return cleaned
  },
  format: (value: string) => {
    // Si está vacío, retornar vacío
    if (!value)
      return ""

    // Solo trabajar con dígitos
    const digits = value.replace(/\D/g, "")

    // Si no hay dígitos, retornar vacío
    if (!digits)
      return ""

    // Formatear según la cantidad de dígitos
    let formatted = ""

    if (digits.length >= 1) {
      formatted += digits[0] // Primer dígito de horas
    }
    if (digits.length >= 2) {
      formatted += digits[1] // Segundo dígito de horas
    }
    if (digits.length >= 3) {
      formatted = `${formatted}:${digits[2]}` // Primer dígito de minutos
    }
    if (digits.length >= 4) {
      formatted += digits[3] // Segundo dígito de minutos
    }
    if (digits.length >= 5) {
      formatted = `${formatted}:${digits[4]}` // Primer dígito de segundos
    }
    if (digits.length >= 6) {
      formatted += digits[5] // Segundo dígito de segundos
    }

    return formatted
  },
  validate: (value: string) => {
    // Validar que el formato sea correcto y tenga al menos HH:MM
    const durationRegex = /^\d{1,2}(?::\d{1,2}(?::\d{1,2})?)?$/
    return durationRegex.test(value) && value.length >= 1
  },
  maxLength: 6, // 6 dígitos máximo (HHMMSS)
  minLength: 1,
  placeholder: "1:30:00",
  errorMessage: "Formato de duración inválido. Use HH:MM:SS (ej: 1:30:00)",
  inputClassName: "font-mono",
}
